"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/operationsViewModel',["require", "exports", "knockout", "../services/vehicleManagementService"], function (require, exports, ko, vehicleManagementService) {
    "use strict";

    var OperationsViewModel = function () {
        function OperationsViewModel() {
            _classCallCheck(this, OperationsViewModel);

            this.tileIndex = 200;
            this.vehicleMakeLookupRequiredCount = ko.observable(0);
            this.vehicleModelLookupRequiredCount = ko.observable(0);
            this.activeVehiclesWithoutGeneration = ko.observable(0);
            this.totalOperationsCount = ko.pureComputed(this.computeTotalOperationsCount, this);
            this.updateInterval = null;
        }

        _createClass(OperationsViewModel, [{
            key: "getVehicleManagementOperationsCount",
            value: function getVehicleManagementOperationsCount() {
                var _this = this;

                vehicleManagementService.getOperationsCounts().done(function (operationsCounts) {
                    if (operationsCounts) {
                        _this.vehicleMakeLookupRequiredCount(operationsCounts.vehicleMakeLookupRequiredCount);
                        _this.vehicleModelLookupRequiredCount(operationsCounts.vehicleModelLookupRequiredCount);
                        _this.activeVehiclesWithoutGeneration(operationsCounts.activeVehiclesWithoutGeneration);
                    }
                });
            }
        }, {
            key: "getNewIndex",
            value: function getNewIndex(tileId) {
                this.tileIndex++;
                return { id: tileId, index: this.tileIndex };
            }
        }, {
            key: "computeTotalOperationsCount",
            value: function computeTotalOperationsCount() {
                return this.vehicleMakeLookupRequiredCount() + this.vehicleModelLookupRequiredCount();
            }
        }, {
            key: "dispose",
            value: function dispose() {}
        }]);

        return OperationsViewModel;
    }();

    return new OperationsViewModel();
});
//# sourceMappingURL=operationsViewModel.js.map;
